import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './plugins/vue-i18n-config';
import "@dt-ecosystem/ui/packages/vue2/dist/style.css"
import './plugins/axios-config';
import './plugins/vue-notification-config';
import './plugins/moment-config';
import './plugins/vuelidate-config';
import './plugins/vue-headful-config';
import './mixins/index';
import './directives/index';
import './filters';
import JsonExcel from "vue-json-excel";
import VueMoment from 'vue-moment';

Vue.use(VueMoment)


Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.component("downloadExcel", JsonExcel);

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)



new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app');
